export default {
	state: {
		orderLoading: {
			loading: false,
		},
	},
	mutations: {
		requestOrdering(state) {
			state.orderLoading.loading = true;
		},
		successOrdered(state) {
			state.orderLoading.loading = false;
		},
	},
	actions: {
		async orderTheClientDetail({ commit }, params) {
			commit('requestOrdering');
			await a.api('updatekhd', params);
			commit('successOrdered');
		},
	},
};
